module.exports = __webpack_public_path__ + "static/media/meal.30b70c37.png";